export const sortByNewest = (currentReq, nextRequest) => {
  const aTime = new Date(currentReq.createdOn).getTime();
  const bTime = new Date(nextRequest.createdOn).getTime();
  const time = Date.now();
  const aDelta = Math.abs(time - aTime);
  const bDelta = Math.abs(time - bTime);

  return aDelta - bDelta;
};
